var _path, _path2;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIconVideo(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 0h32v32H0z"
  })), /*#__PURE__*/React.createElement("g", {
    fill: props.color
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M27 25.673l-5-1.428v-5.492l5-1.428v8.348zM20 26H6v-9h14v9zM28.603 15.2a1.008 1.008 0 00-.877-.163L22 16.673V16a1 1 0 00-1-1H5a1 1 0 00-1 1v11a1 1 0 001 1h16a1 1 0 001-1v-.674l5.726 1.636a1.005 1.005 0 00.877-.163c.25-.189.397-.485.397-.799V16c0-.313-.147-.609-.397-.799zM8 6c1.654 0 3 1.346 3 3s-1.346 3-3 3-3-1.346-3-3 1.346-3 3-3m0 8c2.757 0 5-2.243 5-5s-2.243-5-5-5-5 2.243-5 5 2.243 5 5 5M19 6c1.654 0 3 1.346 3 3s-1.346 3-3 3-3-1.346-3-3 1.346-3 3-3m0 8c2.757 0 5-2.243 5-5s-2.243-5-5-5-5 2.243-5 5 2.243 5 5 5"
  })))));
}

export default SvgIconVideo;